/**
 * `/admin/project-attribute-definitions` — i campi custom di commessa, dalla piattaforma.
 *
 * ⚠️ La schermata **non sta qui**: è `ProjectAttributeDefinitionsPanel`, perché la rende anche la
 * sezione «Campi commessa» di «Regole di lavoro». Questa rotta resta in piedi per i link e i
 * segnalibri già in giro — un indirizzo è dato, e toglierlo non si vede finché qualcuno non ci
 * clicca sopra.
 */
import { createFileRoute } from '@tanstack/react-router';
import { ProjectAttributeDefinitionsPanel } from '@/features/projects/ProjectAttributeDefinitionsPanel';

export const Route = createFileRoute('/_app/admin/project-attribute-definitions')({
  component: ProjectAttributeDefinitionsPanel,
});
